// extracted by mini-css-extract-plugin
export default {"mindPage":"Mind_mindPage__PVu+G"};